import i18n from "./i18n";

function addTranslation(translationObject) {
    i18n.mergeLocaleMessage(
        i18n.locale,
        translationObject[i18n.locale] ?? {}
    );
}

export {
    addTranslation,
}

export default i18n;